<script setup>
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import store from "@/store";
import {payType} from "@/utils/config";
import XiamenLoginComponents from "@/components/xiamen/XiamenLoginComponents.vue";
import XiamenProductComponents from "@/components/xiamen/XiamenProductComponents.vue";
import axiosApi from "@/utils/axiosApi";
import {ElMessage} from "element-plus";
import {scal_login, xm_air_login} from "@/utils/func";
import router from "@/router";

const type = computed(() => {
  let pay = store.state.pay_type
  if (!pay) return {}
  pay = payType[pay]
  document.title = pay.title
  return pay
})
const route = useRoute()
const login = ref(false)
const mobile = ref("")
const showProduct = ref(false)
const product = ref({})
const productList = ref([])
const account = computed(() => {
  const account = store.state.account
  mobile.value = account?.phoneNumber
  return account
})
const unit = computed(() => {
  return type.value.type?.unit || "积分"
})
onMounted(() => {
  if (route.query.pay) {
    store.commit("setPayType", route.query.pay)
  } else {
    store.commit("getPayType")
  }
  if (type.value.type === 'xm_air' && Object.keys(account.value).length > 0) {
    //校验登录信息
    xm_air_login(account.value)
  } else if (type.value.type === 'scal' && Object.keys(account.value).length > 0) {
    //校验登录信息
    scal_login(account.value)
  }
  store.commit("getAccount")
  new axiosApi({
    method: "xiamen/metro_coupon",
    encode: "site",
    body: {
      code: type.value.platform,
      type: type.value.type,
    }
  }).send(res => {
    if (res.message.code !== "000") {
      return ElMessage.error(res.message.content)
    }
    productList.value = res.data[type.value.platform]
  })
});

const productIts = pro => {
  // console.log(pro)
  product.value = pro
  showProduct.value = true
}

const goToOrder = () => {
  router.push({name: 'order'})
}
</script>

<template>

  <el-scrollbar class="page-pid page-home" :style="type.view">
    <div class="banner">
      <el-image :src="type.banner"/>
    </div>
    <div class="login-item">
      <div class="login-item-lst">
        <div class="login-item-lst-value" @click="goToOrder">
          <i class="ticket-font ticket-dingdan6"></i>
          兑换记录
        </div>
        <div class="login-item-lst-value" v-if="Object.keys(account).length" @click="store.commit('removeAccount')">
          <i class="ticket-font ticket-logout"></i>
          退出登录
        </div>
      </div>
    </div>
    <div class="login-account contents">
      <el-card shadow="never">
        <el-input :placeholder="type.account_placeholder" size="large" v-model="mobile">
          <template #prefix>
            <el-icon color="var(--btn-color)" size="22">
              <Search/>
            </el-icon>
          </template>
        </el-input>
        <div class="account-info">
          <el-button type="primary" round color="var(--btn-color)" @click="login=true"
                     v-if="Object.keys(account).length < 1">
            查询可用{{ unit }}
          </el-button>
          <div v-else>
            可用{{ unit }}：<span style="color: var(--text-color)">{{ account.balance_miles }}{{ unit }}</span>
          </div>
        </div>
      </el-card>
    </div>
    <div class="steps">
      <el-image :src="type.steps"/>
    </div>
    <div class="contents coupon-lst">
      <div class="coupon-lst-item" :class="type.type" v-for="(item,index) in productList.coupon" :key="index">
        <div class="coupon-lst-item-left">
          <sup>￥</sup>
          <b class="money">{{ parseFloat(item.face_value) }}</b>
        </div>
        <div class="coupon-lst-item-right">
          <div class="coupon-title">
<!--            <p style="white-space: nowrap">机场高铁站</p>-->
<!--            <p>消费券</p>-->
            机场消费券
          </div>
          <div class="coupon-price">
            <div class="coupon-btn"><b class="prices">{{ item.dis_score }}</b><span>积分</span></div>
            <el-button type="primary" round class="success-recharge" @click="login=true"
                       v-if="Object.keys(account).length < 1">立即兑换
            </el-button>
            <el-button type="primary" round class="success-recharge"
                       v-if="Object.keys(account).length > 1 && item.dis_score <= account.balance_miles"
                       @click="productIts(item)">
              立即兑换
            </el-button>
            <el-button type="primary" round class="fail-recharge"
                       v-else-if="Object.keys(account).length > 1 && item.dis_score > account.balance_miles">可用{{
                unit
              }}不足
            </el-button>
          </div>
        </div>
      </div>

      <div class="recharge" v-for="(recharge,inx) in  type.rechargeText" :key="inx">
        <div class="recharge-title">{{ recharge.title }}</div>
        <ol class="recharge-content">
          <li v-for="i in recharge.content" v-html="i" :key="i"></li>
        </ol>
      </div>
    </div>
    <div class="copyright">
      <p>以上服务由全积分公司提供技术支持</p>
      <p>服务热线：4000-360-195</p>
    </div>
  </el-scrollbar>
  <xiamen-product-components @close="showProduct=false" :show-product="showProduct" :product="product"/>
  <xiamen-login-components :show-login="login" v-if="type.type === 'xm_air'" @closed="login=false" :mobile="mobile"
                           @login="login=false"/>
</template>

<style scoped lang="less">
.page-home {
  height: 100vh;
  background: var(--background-color);

  .steps {
    margin: 20px;
    text-align: center;

    .el-image {
      width: 75%;
      margin: auto;
    }
  }

  .login-item {
    position: relative;
    margin-bottom: 10px;
    top: -125px;

    .login-item-lst {
      position: absolute;
      text-align: center;
      right: 0;
      //
      color: var(--text-color);
      font-weight: 600;
      //
      .login-item-lst-value {
        margin-bottom: 12px;
        border-radius: 45px 0 0 45px;
        background: #ffffff;
        line-height: 30px;
        padding: 0 15px;
        white-space: nowrap;
      }
    }
  }

  .contents {
    margin: 0 15px 15px;

    &.login-account {
      position: relative;
      z-index: 999;
      margin-top: -45px;

      .el-card {
        //width: 62%;
        border-radius: 12px;

        /deep/ .el-input__wrapper {
          box-shadow: none;
          border-bottom: var(--el-border);
        }

        .account-info {
          .el-button {
            width: 100%;
          }
        }
      }
    }
    .coupon-lst-item {
      height: 100px;
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      align-items: center;
      margin: 15px 0;

      &.xm_air {
        background: url('@/assets/images/xm_air/coupon.png') no-repeat;
        background-size: 100% 100%;
        line-height: 1.75;
        gap: 12px;

        .coupon-lst-item-left {
          flex-basis: 28%;
          width: 28%;
          //margin-right: 20px;
          color: var(--text-color);
          text-align: center;
          //font-size: 1.45rem;
          display: flex;
          font-size: 1.2rem;
          justify-content: center;

          .money {
            display: inline-block;
            margin-top: -10px;
            font-size: 1.75rem;
          }
        }

        .coupon-lst-item-right {
          flex-basis: calc(72% - 12px);
          display: flex;
          justify-content: space-between;
          width: calc(72% - 12px);
          align-items: center;

          .coupon-title {
            color: var(--text-color);
            font-weight: 600;
          }

          .coupon-price {
            text-align: center;

            .coupon-btn {
              display: flex;
              justify-content: center;
              align-items: center;

              .prices {
                font-size: 1.4rem;
                color: var(--text-color);
              }
            }

            .el-button {
              width: 110px;

              &.success-recharge {
                background: var(--recharge-success-bg-color);
              }

              &.fail-recharge {
                background: var(--recharge-fail-bg-color);
              }
            }
          }
        }
      }
    }

    .recharge {
      box-sizing: border-box;
      padding: 12px;
      border: 1px solid #5E666F;
      border-radius: 12px;

      .recharge-title {
        background: var(--recharge-title-color);
        padding: 12px;
        color: #fff;
        border-radius: 8px 0 0 8px;
        width: 140px;
        font-weight: 600;
        margin-bottom: 10px;
      }

      .recharge-content {
        text-align: justify;
        padding-left: 15px;
        line-height: 25px;
        font-size: .9rem;
      }
    }
  }
}
</style>
